import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, IconButton, Tooltip, Switch, FormControlLabel, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { treeActions } from '../../redux/slices/treeSlice';

const MappingManager = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mappings = useSelector(state => state.treeData.mappingStates.mappings);
  const automaticMappings = useSelector(state => state.treeData.mappingStates.automaticMappings);
  const showOnlySelectedMappings = useSelector(state => state.treeData.mappingStates.showOnlySelectedMappings);
  const autoMatchingEnabled = useSelector(state => state.treeData.mappingStates.autoMatchingEnabled);
  const isMappingMode = useSelector(state => state.treeData.mappingStates.isMappingMode);
  
  const handleToggleSelectedOnly = () => {
    dispatch(treeActions.setShowOnlySelectedMappings(!showOnlySelectedMappings));
  };
  
  const handleToggleAutoMatching = () => {
    dispatch(treeActions.setAutoMatchingEnabled(!autoMatchingEnabled));
    if (!autoMatchingEnabled) {
      // Clear existing automatic mappings when disabling
      dispatch(treeActions.clearAutomaticMappings());
    }
  };
  
  const handleClearAll = () => {
    dispatch(treeActions.clearMappings());
    dispatch(treeActions.clearAutomaticMappings());
  };
  
  if (!isMappingMode) return null;
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, padding: '4px 8px', borderBottom: '1px solid #e0e0e0' }}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={showOnlySelectedMappings}
            onChange={handleToggleSelectedOnly}
            color="primary"
          />
        }
        label={
          <Tooltip title="Show mapping lines only for selected nodes">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <VisibilityIcon fontSize="small" />
              <span style={{ fontSize: '12px' }}>Selected Only</span>
            </Box>
          </Tooltip>
        }
        sx={{ margin: 0 }}
      />
      
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={autoMatchingEnabled}
            onChange={handleToggleAutoMatching}
            color="secondary"
          />
        }
        label={
          <Tooltip title="Automatically show mappings for fields with matching names">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <AutoAwesomeIcon fontSize="small" />
              <span style={{ fontSize: '12px' }}>Auto Match</span>
            </Box>
          </Tooltip>
        }
        sx={{ margin: 0 }}
      />
      
      <Box sx={{ fontSize: '12px', color: '#666', marginLeft: 1 }}>
        {mappings.length} manual, {automaticMappings.length} auto
      </Box>
      
      <Tooltip title="Clear all mappings">
        <IconButton 
          size="small" 
          onClick={handleClearAll}
          sx={{ marginLeft: 'auto' }}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default MappingManager; 